import React, { useEffect } from "react";
import Main from "../../../Main/Main";
import Tabs from "../../Tabs/Tabs";
import Details from "../../Details/Details";
import DetailsData from "./DetailsFoodData";
function Food({ title }) {
  useEffect(() => {
    document.title = title;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [title]);
  return (
    <div>
      <Main
        heading="FOOD & GROCERIES"
        description="Innovation and simplicity makes us happy"
      />
      <Tabs active="4" />
      <Details data={DetailsData} />
    </div>
  );
}

export default Food;
